import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput"]

  sourceTypeChanged(event) {
    // Clear the name search when changing source type
    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = ""
    }
    
    // Auto-submit the form
    this.element.submit()
  }
}